import { useState, useEffect } from 'react';
import { anotherInstance } from './hookConnect'

const useCourses = () => {
    const [courses, setCourses] = useState([]); // Инициализация как пустой массив
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const reloadData = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };    

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await anotherInstance.get(`courses/get`);
                setCourses(response.data); // Убедитесь, что это массив
            } catch (err) {
                setError(err);
                console.error("Ошибка при получении курсов:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, [refreshKey]);

    const addCourse = async (newCourse) => {
        try {
            const response = await anotherInstance.post(`courses/post`, newCourse);
            setCourses(prevCourses => [...prevCourses, response.data]); // Добавляем один курс
        } catch (err) {
            throw err; // Пробрасываем ошибку дальше
        }
    }; 

    const editCourse = async (updatedCourse) => {
        try {

            await anotherInstance.put(`courses/put/${updatedCourse.id}`, updatedCourse);
        } catch (err) {
            throw err;
        }
    };
    const deleteCourse = async (courseId) => {
        try {
            await anotherInstance.delete(`courses/del/${courseId}`);
            setCourses(prevCourses => prevCourses.filter(course => course.id !== courseId));
        } catch (err) {
            throw err; // Пробрасываем ошибку дальше
        }
    };

    return { courses, loading, addCourse, deleteCourse, editCourse, reloadData };
};

export default useCourses;
